import AdoptionForm from '@/components/fosters/adoptions/AdoptionForm'
import trpc from '@/utils/trpc'

interface Props {
  open: boolean
  onClose: () => void
  fosterId: string
}

const NewAdoptionAction = ({ open, onClose, fosterId }: Props) => {
  const newAdoptionRecordMutation = trpc.foster.adoptions.create.useMutation()

  return (
    <AdoptionForm
      fosterId={fosterId}
      mutation={newAdoptionRecordMutation}
      onClose={onClose}
      open={open}
    />
  )
}

export default NewAdoptionAction
